import { trackEvent } from "@/lib/audit";
import { PREVIEW_MODE } from "@/lib/previewMode";

export interface NextMatchInfo {
  match_id: string;
  home_label: string;
  away_label: string;
  kickoff_iso: string;
  competition?: string;
}

const KEY = "ss2026_next_match_v1";
const REMINDER_KEY = "ss2026_next_match_reminders_v1";

export function setNextMatch(info: NextMatchInfo) {
  if (typeof window === "undefined") return;
  localStorage.setItem(KEY, JSON.stringify(info));
}

export function getNextMatch(): NextMatchInfo | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const v = JSON.parse(raw) as NextMatchInfo;
      if (new Date(v.kickoff_iso).getTime() > Date.now() - 1000 * 60 * 30) return v;
    }
  } catch { /* noop */ }
  // Fallback: next-known fixture (Mundial 2026 placeholder window).
  const tomorrow = new Date(Date.now() + 1000 * 60 * 60 * 24);
  tomorrow.setHours(20, 0, 0, 0);
  return {
    match_id: "demo-next",
    home_label: PREVIEW_MODE ? "España" : "México",
    away_label: "Argentina",
    kickoff_iso: tomorrow.toISOString(),
    competition: "Mundial 2026",
  };
}

export function msUntil(iso: string): number {
  return Math.max(0, new Date(iso).getTime() - Date.now());
}

export function formatCountdown(ms: number): { d: number; h: number; m: number; s: number; label: string } {
  const s = Math.floor(ms / 1000);
  const d = Math.floor(s / 86400);
  const h = Math.floor((s % 86400) / 3600);
  const m = Math.floor((s % 3600) / 60);
  const sec = s % 60;
  const pad = (n: number) => String(n).padStart(2, "0");
  const label = d > 0 ? `${d}d ${pad(h)}h ${pad(m)}m` : `${pad(h)}:${pad(m)}:${pad(sec)}`;
  return { d, h, m, s: sec, label };
}

export function isReminderSet(matchId: string): boolean {
  if (typeof window === "undefined") return false;
  try {
    const raw = localStorage.getItem(REMINDER_KEY);
    const arr = raw ? (JSON.parse(raw) as string[]) : [];
    return arr.includes(matchId);
  } catch { return false; }
}

export function setReminder(matchId: string) {
  if (typeof window === "undefined") return;
  try {
    const raw = localStorage.getItem(REMINDER_KEY);
    const arr = raw ? (JSON.parse(raw) as string[]) : [];
    if (!arr.includes(matchId)) {
      arr.push(matchId);
      localStorage.setItem(REMINDER_KEY, JSON.stringify(arr));
    }
    void trackEvent("next_match_reminder_set", { match_id: matchId });
  } catch { /* noop */ }
}